export default "__VITE_ASSET__LuBDeMMB__"